module.exports = __webpack_public_path__ + "media/images/store_btn_l-c9222f2c13f56d1217d1637c91f0f4a3.gif";